import { render } from "./train.vue?vue&type=template&id=5bcfee06"
import script from "./train.vue?vue&type=script&lang=js"
export * from "./train.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__